import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
import Swiper from "swiper";

gsap.registerPlugin(SplitText);

export default function carouselAnimation() {
    if($('.carousel-content').length > 0) {
        const carouselItems = gsap.utils.toArray(".carousel-content h2");
        const tl = gsap.timeline();

        tl.to('.carousel-content', {opacity: 1});

        carouselItems.forEach((item) => {
            let text = new SplitText(item, { types: 'words' })

            tl.from(text.words, {
                opacity: 0,
                y: 20,
                duration: 0.5,
                stagger: {amount: 0.75},
            })
                .to(text.words, {
                    opacity: 1,
                    y: 0,
                    duration: 2,
                    stagger: {amount: 0.75},
                })
                .to(text.words, {
                    opacity: 0,
                    y: -20,
                    duration: 0.5,
                    stagger: {amount: 0.75}
                });
        });
        tl.repeat(-1);
    }

    var carousel = new Swiper(".carousel", {
        loop: true,
        effect: 'fade',
        speed: 1000,
        slidesPerView: 1,
        allowTouchMove: false,
        autoplay: {
            delay: 4500,
        },
    });
}
